import { Loader2 } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { TarjetaTrivia } from '@/features/comunidad'
import { NovedadCuerpo } from './NovedadCuerpo'
import { PortadaProducto } from './PortadaProducto'
import { useNovedadesAlEntrar } from './useNovedadesAlEntrar'

/**
 * `/app/novedades` — la página que rescata a quien cerró el aviso sin leerlo
 * (goal novedades-del-portal 2, decisión 1 de Víctor: aviso una sola vez + una
 * página propia, no una pantalla de inicio obligatoria).
 *
 * Misma fuente que el aviso: se ignora `pendiente` (aquí se entra a propósito,
 * lo haya visto o no) y se pinta la misma lista con la portada ANCHA, que es
 * donde sí cabe el rótulo dentro.
 */
export function NovedadesPage() {
  const { t } = useTranslation()
  const estado = useNovedadesAlEntrar()

  return (
    <div className="mx-auto w-full max-w-5xl">
      <h1 className="mb-1 text-[27px] font-bold tracking-tight text-ink">
        {t('novedades.tituloPagina')}
      </h1>
      <p className="mb-6 text-sm text-ink-muted">
        {t('novedades.subtituloPagina')}
      </p>

      {/* Acceso a la trivia semanal (goal trivias 5). Va arriba y fuera de los
          estados de la consulta: no depende de que haya novedades ni de que el
          servidor responda. Sin `VITE_COMUNIDAD_URL` no se pinta. */}
      <TarjetaTrivia />
      {estado.estado === 'cargando' && (
        <div className="flex items-center gap-2 py-10 text-sm text-ink-muted">
          <Loader2 className="h-4 w-4 animate-spin" aria-hidden="true" />
          {t('common.loading')}
        </div>
      )}

      {/* Un fallo del servidor NO se disfraza de «aún no hay novedades»: son
          cosas distintas y decir la que no es deja al usuario esperando algo
          que ya llegó. */}
      {estado.estado === 'falla' && (
        <p className="rounded-card border border-line bg-panel px-5 py-8 text-center text-sm text-ink-muted">
          {t('novedades.error')}
        </p>
      )}

      {estado.estado === 'listo' && estado.datos.novedades.length === 0 && (
        <p className="rounded-card border border-line bg-panel px-5 py-8 text-center text-sm text-ink-muted">
          {t('novedades.vacio')}
        </p>
      )}

      {estado.estado === 'listo' && estado.datos.novedades.length > 0 && (
        <div className="grid gap-4 sm:grid-cols-2">
          {estado.datos.novedades.map((novedad) => (
            <article
              key={`${novedad.repo}-${novedad.version}`}
              className="rounded-card border border-line bg-panel p-3.5"
            >
              <PortadaProducto product={novedad.product} medida="ancha" />
              <div className="mt-3">
                <NovedadCuerpo novedad={novedad} conProducto={false} />
              </div>
            </article>
          ))}
        </div>
      )}
    </div>
  )
}
